import React, { useCallback } from "react";
import "./moftabakh.css";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import Lottie from "react-lottie-player";
import lottieJson from "../../moftabakh.json";
import { Link, useNavigate } from "react-router-dom";
import { useInputMode } from "../../utils/hooks/useInputMode";

const MoftabakhLogo = () => {
  return (
    <div className="inset-0 z-10">
      <div className="w-48 ml-48 rounded-xl mr-auto">
        <Lottie
          loop
          animationData={lottieJson}
          play={true}
          style={{
            width: 365,
            borderRadius: "20px",
            transition: "all ease .3s",
          }}
        />
      </div>
    </div>
  );
};

const MoftaBakh = ({ onFocus, index }) => {
  const navigate = useNavigate();
  const { focused, focusKey, ref, focusSelf } = useFocusable({
    onFocus,
    focusKey: "moftabakh_home",
    isFocusBoundary: true,
    focusBoundaryDirections: ["left"],
    onEnterPress: () => navigate("/moftabakh"),
    onArrowPress: (direction) => {
      if (direction === "right") {
        return true;
      }
      return true;
    },
  });

  const { setMouseFocus } = useInputMode();
  const handleMouseEnter = useCallback(() => {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <Link to="/moftabakh">
        <div
          ref={ref}
          className={"legacy-home-feature-banner" + (focused ? " is-focused" : "")}
          onMouseEnter={handleMouseEnter}
          tabIndex={index}
        >
          <MoftabakhLogo />
        </div>
      </Link>
    </FocusContext.Provider>
  );
};

export default MoftaBakh;
